// // ExpertConnect.jsx
// // ExpertConnect.jsx
// import React, { useState } from 'react';
// import {
//   Users,
//   ArrowRight,
//   Star,
//   Clock,
//   Award,
//   Briefcase,
//   User,
//   Mail,
//   Phone,
//   MapPin,
//   CheckCircle,
//   Sparkles,
//   Shield,
//   Zap,
//   Search,
//   Filter,
//   TrendingUp,
//   Crown,
//   MessageCircle,
//   Calendar,
//   Lock,
//   Eye,
//   EyeOff,
//   LogIn as LoginIcon,
//   Building2,
//   Factory
// } from 'lucide-react';
// import './ExpertConnect.css';
// import Navbar from './Navbar';
// import WhyConsultFirst from './WhyConsultFirst';
// import Expertteam from './Expertteam';
// import Footer from './Footer';
// import { useNavigate } from 'react-router-dom';

// const ExpertConnect = () => {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [rememberMe, setRememberMe] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [loginError, setLoginError] = useState('');

//   const experts = [
//     {
//       id: 1,
//       name: "Ravi Kumar",
//       role: "CAD & DFM Expert",
//       experience: "15 yrs",
//       rate: "₹500",
//       rating: 4.9,
//       reviews: 127,
//       avatar: "RK",
//       expertise: ["CAD Modeling", "DFM Analysis", "3D Printing"],
//       availability: "Available Now",
//       verified: true,
//       image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=center&auto=format&q=80"
//     },
//     {
//       id: 2,
//       name: "Priya Sharma",
//       role: "Product Design Engineer",
//       experience: "10 yrs",
//       rate: "₹650",
//       rating: 4.8,
//       reviews: 98,
//       avatar: "PS",
//       expertise: ["Product Design", "Prototyping", "3D Modeling"],
//       availability: "Busy",
//       verified: true,
//       image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=center&auto=format&q=80"
//     },
//     {
//       id: 3,
//       name: "Amit Patel",
//       role: "Manufacturing Specialist",
//       experience: "12 yrs",
//       rate: "₹750",
//       rating: 4.7,
//       reviews: 85,
//       avatar: "AP",
//       expertise: ["Manufacturing", "Process Optimization", "Quality Control"],
//       availability: "Available Now",
//       verified: true,
//       image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=center&auto=format&q=80"
//     }
//   ];

//   const stats = [
//     { value: "500+", label: "Experts" },
//     { value: "4.8", label: "Avg Rating" },
//     { value: "95%", label: "Success Rate" },
//     { value: "50+", label: "Expertise Areas" }
//   ];

//   const handleLogin = (e) => {
//     e.preventDefault();
//     setLoginError('');
//     setIsLoading(true);

//     // Simulate login
//     setTimeout(() => {
//       setIsLoading(false);
//       if (email === 'expert@apic.in' && password === 'password') {
//         // Navigate to expert dashboard or marketplace
//         navigate('/expert-marketplace');
//       } else {
//         setLoginError('Invalid email or password. Please try again.');
//       }
//     }, 1500);
//   };

//   return (
//     <>
//       <Navbar />
//       <section className="expert-connect">
//         {/* Background Image */}
//         <div className="expert-bg-container">
//           <img
//            src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1600&q=80"
//             alt="Expert network background"
//             className="expert-bg-image"
//           />
//           <div className="expert-bg-overlay"></div>
//           <div className="expert-bg-glow-1"></div>
//           <div className="expert-bg-glow-2"></div>
//         </div>

//         <div className="expert-container">
//           {/* ========== HERO SECTION ========== */}
//           <div className="expert-hero">
//             {/* Left Side - Text Content */}
//             <div className="expert-hero-left">
//               <div className="expert-badge">
//                 <Sparkles size={16} className="expert-badge-icon" />
//                 <span>Expert Network</span>
//               </div>

//               <h1 className="expert-hero-title">
//                 <span className="expert-hero-title-line1">The right expertise can turn</span>
//                 <span className="expert-hero-title-line2">a good idea into a great product.</span>
//               </h1>

//               <p className="expert-hero-description">
//                 Every successful prototype starts with the right technical decisions. 
//                 APIC ProtoHub connects innovators with engineers, product designers, 
//                 manufacturing specialists and technology experts who help transform 
//                 ideas into technically feasible, manufacturable, cost-effective products.
//               </p>

//               {/* CTA Buttons */}
//               <div className="expert-hero-cta">
//                 <button className="expert-cta-primary">
//                   <Search size={18} />
//                   <span>Find an Expert</span>
//                   <ArrowRight size={18} className="expert-cta-arrow" />
//                 </button>
//                 <button className="expert-cta-secondary">
//                   <User size={18} />
//                   <span>Become an Expert</span>
//                 </button>
//               </div>

//               {/* Stats */}
//               <div className="expert-stats">
//                 {stats.map((stat, index) => (
//                   <React.Fragment key={index}>
//                     <div className="expert-stat-item">
//                       <p className="expert-stat-value">{stat.value}</p>
//                       <p className="expert-stat-label">{stat.label}</p>
//                     </div>
//                     {index < stats.length - 1 && (
//                       <div className="expert-stat-divider"></div>
//                     )}
//                   </React.Fragment>
//                 ))}
//               </div>
//             </div>

//             {/* Right Side - Login Form */}
//             <div className="expert-hero-right">
//               <div className="expert-login-card">
//                 <div className="expert-login-header">
                  
//                   <h2 className="expert-login-title">Welcome Back</h2>
//                   <p className="expert-login-subtitle">Sign in to access expert network</p>
//                 </div>

//                 <form className="expert-login-form" onSubmit={handleLogin}>
//                   <div className="expert-login-group">
//                     <label className="expert-login-label">
//                       <Mail size={16} />
//                       Email Address
//                     </label>
//                     <div className="expert-login-input-wrapper">
//                       <Mail size={18} className="expert-login-input-icon" />
//                       <input
//                         type="email"
//                         className="expert-login-input"
//                         placeholder="expert@apic.in"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                         required
//                       />
//                     </div>
//                   </div>

//                   <div className="expert-login-group">
//                     <label className="expert-login-label">
//                       <Lock size={16} />
//                       Password
//                     </label>
//                     <div className="expert-login-input-wrapper">
//                       <Lock size={18} className="expert-login-input-icon" />
//                       <input
//                         type={showPassword ? 'text' : 'password'}
//                         className="expert-login-input"
//                         placeholder="Enter your password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         required
//                       />
//                       <button
//                         type="button"
//                         className="expert-login-password-toggle"
//                         onClick={() => setShowPassword(!showPassword)}
//                       >
//                         {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//                       </button>
//                     </div>
//                   </div>

//                   {loginError && (
//                     <div className="expert-login-error">
//                       <AlertCircle size={16} />
//                       <span>{loginError}</span>
//                     </div>
//                   )}

//                   <div className="expert-login-options">
//                     <label className="expert-login-checkbox">
//                       <input
//                         type="checkbox"
//                         checked={rememberMe}
//                         onChange={(e) => setRememberMe(e.target.checked)}
//                       />
//                       <span>Remember me</span>
//                     </label>
//                     <a href="#" className="expert-login-forgot">Forgot password?</a>
//                   </div>

//                   <button
//                     type="submit"
//                     className="expert-login-submit"
//                     disabled={isLoading}
//                   >
//                     {isLoading ? (
//                       <>
//                         <span className="expert-login-spinner"></span>
//                         Signing in...
//                       </>
//                     ) : (
//                       <>
//                         <LoginIcon size={18} />
//                         Sign In
//                       </>
//                     )}
//                   </button>

//                 </form>
//               </div>
//             </div>
//           </div>

//           {/* ========== EXPERTS SECTION ========== */}
          
//         </div>
//       </section>
//       <Expertteam />
//       <WhyConsultFirst />
//       <Footer />
//     </>
//   );
// };

// // AlertCircle icon component
// const AlertCircle = ({ size = 16 }) => (
//   <svg
//     width={size}
//     height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <circle cx="12" cy="12" r="10"/>
//     <line x1="12" y1="8" x2="12" y2="12"/>
//     <line x1="12" y1="16" x2="12.01" y2="16"/>
//   </svg>
// );

// export default ExpertConnect;




import React from "react";
import { Sparkles, ArrowRight, Star } from "lucide-react";
import Navbar from './Navbar';
import Invotorexperience from './Invotorexperience'
import Invoterexpert from './Invoterexpert'
import Invoterguidence from './Invoterguidence'
import Invotergudienceexpert from './Invotergudienceexpert';
import Invoterexpertexplore from './Invoterexpertexplore';
import Invoterincometeam from './Invoterincometeam';
import Invoterexpertbecome from './Invoterexpertbecome';
import WhyConsultFirst from './WhyConsultFirst'

export default function Hero() {
  return (
    <>
    <Navbar/>
    <section className="relative w-full min-h-screen bg-[#0a0f1e] overflow-hidden">
      {/* subtle grid background */}
      <div
        className="absolute inset-0 opacity-[0.15] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, #ffffff10 1px, transparent 1px), linear-gradient(to bottom, #ffffff10 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      {/* top hairline */}
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-white/20 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-10 items-center">
          {/* LEFT: Copy */}
          <div className="flex flex-col items-start">
            {/* Eyebrow badge */}
            <div className="inline-flex items-center gap-2 rounded-full border border-amber-400/40 bg-amber-400/5 px-4 py-2 mb-8">
              <Sparkles className="w-3.5 h-3.5 text-amber-400" />
              <span className="text-[11px] sm:text-xs tracking-[0.15em] font-semibold text-amber-400 uppercase">
                Engineering Expertise &middot; Innovation &middot; Prototyping
              </span>
            </div>

            {/* Headline */}
            <h1 className="font-serif text-white leading-[1.05] text-4xl sm:text-5xl md:text-6xl lg:text-[3.6rem] xl:text-7xl">
              The right expertise can turn a good idea into a{" "}
              <span className="italic text-amber-400 font-serif">
                great product.
              </span>
            </h1>

            {/* Paragraph */}
            <p className="mt-7 text-slate-400 text-base sm:text-lg leading-relaxed max-w-xl">
              Every successful prototype starts with the right technical
              decisions. APIC ProtoHub connects innovators with engineers,
              product designers, manufacturing specialists and technology
              experts who help transform ideas into technically feasible,
              manufacturable, cost-effective products.
            </p>

            {/* CTAs */}
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button className="group inline-flex items-center gap-2 rounded-lg bg-amber-400 hover:bg-amber-300 transition-colors px-6 py-3.5 font-semibold text-[#0a0f1e] text-sm sm:text-base">
                Find an Expert
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
              </button>
              <button className="inline-flex items-center rounded-lg border border-white/15 hover:border-white/30 transition-colors px-6 py-3.5 font-semibold text-white text-sm sm:text-base">
                Become an Expert
              </button>
              <button className="text-slate-300 hover:text-white transition-colors text-sm sm:text-base font-medium px-2">
                Login
              </button>
            </div>
          </div>

          {/* RIGHT: Image + floating card */}
          <div className="relative w-full">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] sm:aspect-[16/11] shadow-2xl shadow-black/50 ring-1 ring-white/10">
              <img
                src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=1600&auto=format&fit=crop"
                alt="Engineers reviewing a CAD model on screen"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0f1e]/70 via-transparent to-transparent" />
            </div>

            {/* Floating expert card */}
            <div className="absolute left-4 right-4 -bottom-8 sm:left-6 sm:right-auto sm:-bottom-10 sm:w-[340px] rounded-xl bg-[#101a30]/95 backdrop-blur border border-white/10 shadow-xl p-4 sm:p-5">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-amber-400 flex items-center justify-center font-bold text-[#0a0f1e] text-sm shrink-0">
                  RK
                </div>
                <div className="min-w-0">
                  <p className="text-white font-semibold text-sm sm:text-base truncate">
                    Ravi Kumar
                  </p>
                  <p className="text-slate-400 text-xs sm:text-sm truncate">
                    CAD &amp; DFM Expert &middot; 15 yrs
                  </p>
                </div>
              </div>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-slate-300 text-xs sm:text-sm">
                  from &#8377;500 / 30 min
                </span>
                <span className="inline-flex items-center gap-1 text-amber-400 text-xs sm:text-sm font-semibold">
                  <Star className="w-3.5 h-3.5 fill-amber-400" />
                  4.9
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* spacer so floating card doesn't overlap next section on mobile */}
      <div className="h-12 sm:h-16" />
    </section>
    <Invotorexperience/>
    <Invoterexpert/>
    <Invoterguidence/>
    <Invotergudienceexpert/>
     <WhyConsultFirst />
    <Invoterexpertexplore/>
    <Invoterincometeam/>
    <Invoterexpertbecome/>


    </>
  );
}